import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const VerifyCode = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [code, setCode] = useState("");
  const email = location.state?.email?.trim() || "yourmail@domain.com";

  return (
    <section className="relative w-full min-h-screen overflow-x-hidden bg-black font-[Poppins]">
      <img
        src="images/top.png"
        alt="Top"
        className="pointer-events-none absolute top-0 left-1/2 w-[140%] max-w-none -translate-x-1/2 opacity-40 sm:w-full sm:max-w-2xl sm:opacity-60"
      />
      <img
        src="images/leftcorner.png"
        alt="Left"
        className="pointer-events-none absolute bottom-[-4rem] left-[-6rem] hidden w-64 opacity-40 sm:left-[-3rem] sm:block sm:opacity-70 md:bottom-0"
      />
      <img
        src="images/right-corner.png"
        alt="Right"
        className="pointer-events-none absolute bottom-[-4rem] right-[-6rem] hidden w-64 opacity-40 sm:right-[-3rem] sm:block sm:opacity-70 md:bottom-0"
      />
      <img
        src="images/synergy.png"
        alt="Left Coin"
        className="pointer-events-none absolute left-[-4rem] top-1/3 hidden w-32 opacity-50 sm:block sm:left-6 sm:w-40 sm:opacity-80 md:left-12 md:w-[10rem]"
      />
      <img
        src="images/synergy.png"
        alt="Right Coin"
        className="pointer-events-none absolute right-[-3rem] top-[22%] hidden w-20 opacity-50 sm:block sm:right-10 sm:w-28 sm:opacity-80 md:right-12"
      />

      <div className="relative z-20 flex min-h-screen flex-col">
        <div className="flex items-center justify-between px-4 py-5 sm:px-6">
          <img src="images/login-logo.png" alt="Logo" className="h-8 w-auto sm:h-10" />
          <button
            onClick={() => navigate("/signup")}
            className="rounded-full border border-white/20 px-4 py-1.5 text-sm text-white transition hover:border-white/40 hover:text-purple-300 sm:px-5"
          >
            Sign Up
          </button>
        </div>

        <div className="flex flex-1 items-start justify-center px-4 pb-14 pt-8 sm:items-center sm:px-6">
          <div className="w-full max-w-[520px] text-center">
            <h1 className="text-3xl font-semibold tracking-tight text-transparent bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text sm:text-4xl">
              Let us know it&apos;s you
            </h1>
            <p className="mx-auto mt-3 max-w-md text-sm text-gray-300 sm:text-base">
              Last step! To secure your account, enter the code we just sent to {email}.
            </p>

            <div className="mx-auto mt-10 max-w-md text-left">
              <label className="mb-2 block text-sm text-gray-200">Code</label>
              <input
                type="text"
                name="code"
                placeholder="Enter code"
                value={code}
                onChange={(event) => setCode(event.target.value)}
                className="w-full rounded-xl border border-white/10 bg-black/60 px-4 py-3 text-sm text-gray-100 placeholder:text-gray-500 focus:border-purple-400 focus:outline-none"
              />
              <button
                type="button"
                onClick={() => navigate("/forgot-password/reset")}
                className="mt-6 w-full rounded-xl bg-gradient-to-r from-[#7F3FFD] to-[#9F4FFF] py-3 text-sm font-semibold text-white transition hover:brightness-110"
              >
                Proceed
              </button>
            </div>

            <p className="mt-6 text-center text-xs text-gray-400">
              By using SynergyCoin, you agree to our terms and policy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifyCode;
